import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const AllCases = lazy(() => import('./AllCases.jsx'))
const AllCasesSingleView = lazy(() => import('./AllCasesSingleView.jsx'))    


const AllCasesRoutes = [
    {
        path: '/AllCases',
        component: AllCases,
        auth: authRoleAccess.all_cases,
    },

    {
        path: '/AllCasesSingleView/:id',
        component: AllCasesSingleView,
        auth: authRoleAccess.all_cases,
    },

]

export default AllCasesRoutes 